import React from 'react';
import withStore from "@/hocs/withStore";
import Chip from '@material-ui/core/Chip';
import {ucFirst} from "@/Helpers/Function";
import {makeStyles} from "@material-ui/core/styles";
import LinkLoad from "@/Layouts/LinkLoad";

const useStyles = makeStyles((theme) => ({
    chip: {
        border: '1px solid #B1CBC3',
        borderRadius: '10px',
        marginRight: '15px',
        marginBottom: '15px',
        height: '100%',
        minHeight: '32px',
        paddingTop: '8px',
        paddingBottom: '8px',
        whiteSpace: 'normal',
    }
}));

const Tag = (props) => {
    const {stores = {}, seoText = '', tagOne = []} = props;
    const {filterStore = {}} = stores;

    const classes = useStyles();
    if (seoText === '' && tagOne.length === 0) return null

    return (
        <>
            {(seoText !== '') && (
                <p className={`seo-text__text`}>
                    {seoText}
                </p>
            )}
            {tagOne.length !== 0 && (
                <>
                    <div className={`tag-h2`} style={{fontWeight: 700}}>
                        С этими товарами ищут
                    </div>
                    <div className={`tag`}>
                        {tagOne.map((el, i) => {
                            return <LinkLoad key={i} href={`${el.href}`} onClick={() => filterStore.handleClickLink()}>
                                <Chip component='span'
                                    clickable
                                    className={classes.chip}
                                    label={ucFirst(el.value)}
                                    variant='outlined'
                                />
                            </LinkLoad>
                        })}
                    </div>
                </>
            )}
        </>
    );
}

export default withStore(Tag);
